import { useNavigate } from 'react-router-dom'

import { Button } from './ui/button'

export function ErrorPage() {
	const navigate = useNavigate()

	const handleBack = () => {
		navigate(-1)
	}
	return (
		<div className="flex flex-col justify-center items-center w-full h-screen">
			<h1 className="text-lg font-bold">Ooops...</h1>

			<p className="text-md mt-4">Pagina não encontrada</p>

			<Button onClick={handleBack}>Voltar</Button>
		</div>
	)
}
